import React, { useEffect, useState, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

export default function FruitBasketSplit() {
  const fruitImages = [
    // 'https://cdn-icons-png.flaticon.com/512/590/590685.png',
    // 'https://cdn-icons-png.flaticon.com/512/590/590703.png',
    // 'https://cdn-icons-png.flaticon.com/512/590/590717.png',
    "https://static.vecteezy.com/system/resources/previews/018/931/579/non_2x/red-apple-fruit-icon-png.png",
    "https://png.pngtree.com/png-vector/20250618/ourmid/pngtree-cute-banana-vector-art-png-image_16548532.png",
    "https://images.vexels.com/media/users/3/143191/isolated/preview/925871db899c05172adae868b7ca93c0-orange-color-icon.png",
    "https://images.vexels.com/media/users/3/211010/isolated/preview/8ee96333a7d8599d5d876562db5265d6-grapes-bunch-hand-drawn.png"

    // "https://www.flaticon.com/free-icon/apple_3137044?term=fruits&page=1&position=3&origin=search&related_id=3137044"
  ];

  const [totalFruits, setTotalFruits] = useState(15);
  const [totalBaskets, setTotalBaskets] = useState(3);
  const [fruitType, setFruitType] = useState(fruitImages[0]);
  const [resultText, setResultText] = useState('');
  const [dropCounts, setDropCounts] = useState([]);

  const fruitRefs = useRef({});
  const basketRefs = useRef([]);

  const generatePuzzle = () => {
    let fruits, baskets;
    do {
      fruits = Math.floor(Math.random() * 21) + 10;
      baskets = Math.floor(Math.random() * 5) + 2;
    } while (fruits % baskets !== 0);

    setTotalFruits(fruits);
    setTotalBaskets(baskets);
    setFruitType(fruitImages[Math.floor(Math.random() * fruitImages.length)]);
    setResultText('');
    fruitRefs.current = {};
    basketRefs.current = [];
    setDropCounts(Array(baskets).fill(0));
  };

  useEffect(() => {
    generatePuzzle();
  }, []);

  const handleDrop = (e, basketIndex) => {
    e.preventDefault();
    const fruitId = e.dataTransfer.getData('text');
    if (fruitId) {
      setDropCounts((prev) => {
        const updated = [...prev];
        updated[basketIndex] += 1;
        return updated;
      });
    }
  };

  return (
    <div style={{
      background: '#f0fff0',
      fontFamily: "'Comic Sans MS', cursive",
      textAlign: 'center',
      padding: '2rem 1rem',
      minHeight: '100vh',
      boxSizing: 'border-box'
    }}>
      <h2 style={{ color: '#4caf50', fontSize: 'clamp(1.4rem, 5vw, 2rem)' }}>🍓 Market Basket Split</h2>
      <p style={{ fontSize: 'clamp(1rem, 3vw, 1.3rem)' }}>
        How can we share <strong>{totalFruits} fruits</strong> in{' '}
        <strong>{totalBaskets} baskets</strong>?
      </p>

      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '10px',
        margin: '20px auto',
        padding: '10px',
        maxWidth: '700px'
      }}>
        {[...Array(totalFruits)].map((_, i) => (
          <div
            key={i}
            id={`fruit${i}`}
            ref={(el) => (fruitRefs.current[`fruit${i}`] = el)}
            style={{
              width: 'clamp(40px, 8vw, 60px)',
              height: 'clamp(40px, 8vw, 60px)',
              backgroundImage: `url(${fruitType})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              cursor: 'grab'
            }}
            draggable
            onDragStart={(e) => e.dataTransfer.setData('text', e.target.id)}
          />
        ))}
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '20px',
        marginTop: '30px'
      }}>
        {[...Array(totalBaskets)].map((_, i) => (
          <div
            key={i}
            ref={(el) => (basketRefs.current[i] = el)}
            style={{
              width: 'clamp(80px, 20vw, 120px)',
              height: 'clamp(80px, 20vw, 120px)',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              border: '2px dashed #000000',
              borderRadius: '10px',
              padding: '5px',
              position: 'relative',
              boxSizing: 'border-box'
            }}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => handleDrop(e, i)}
          >
            {dropCounts[i] > 0 && (
              <>
                <div style={{
                  width: '80%',
                  height: '80%',
                  backgroundImage: `url(${fruitType})`,
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  position: 'absolute',
                  top: '20%',
                  left: '20%'
                }} />
                <div style={{
                  position: 'absolute',
                  // bottom: '0',
                  width: '100%',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
                  color: 'black'
                }}>
                  {dropCounts[i]}
                </div>
              </>
            )}
          </div>
        ))}
      </div>

      <div style={{ marginTop: '30px' }}>
        <button style={{
          fontSize: 'clamp(1rem, 2.8vw, 1.1rem)',
          padding: '10px 20px',
          backgroundColor: '#4caf50',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          marginRight: '10px'
        }} onClick={() => {
          const expected = totalFruits / totalBaskets;
          const allEqual = dropCounts.every(count => count === expected);
          setResultText(allEqual
            ? `🎉 Great job! Each basket has ${expected} fruits!`
            : `❌ Oops! Try again and share equally.`);
             if (allEqual) {
    const responsedata = ConstructorEventUpdateSQLStatus();
    console.log("Event completed", responsedata);
  }
        }}>
          Check ✅
        </button>
        <button style={{
          fontSize: 'clamp(1rem, 2.8vw, 1.1rem)',
          padding: '10px 20px',
          backgroundColor: '#4caf50',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer'
        }} onClick={generatePuzzle}>
          Next Puzzle 🔁
        </button>
      </div>

      <div style={{
        marginTop: '20px',
        fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
        fontWeight: 'bold',
        color: resultText.includes('Great') ? 'green' : 'red'
      }}>
        {resultText}
      </div>
    </div>
  );
}
